export enum DDRTypeEnum {
  LACTATINGMOTHER3150 = 'LactatingMother3150',
  LACTATINGMOTHER1930 = 'LactatingMother1930',
  LACTATINGMOTHER18 = 'LactatingMother18',
  PREGNANT3150 = 'Pregnant3150',
  PREGNANT1930 = 'Pregnant1930',
  PREGNANT18 = 'Pregnant18',
  MEN913 = 'Men913',
  MEN1418 = 'Men1418',
  MEN1930 = 'Men1930',
  MEN3150 = 'Men3150',
  MEN5170 = 'Men5170',
  MEN70 = 'Men70',
  WOMAN913 = 'Woman913',
  WOMAN1418 = 'Woman1418',
  WOMAN1930 = 'Woman1930',
  WOMAN3150 = 'Woman3150',
  WOMAN5170 = 'Woman5170',
  WOMAN70 = 'Woman70',
}
